import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, MapPin, Users } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden mb-[15px]" data-id="element-169">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand/20 blur-[120px] rounded-full pointer-events-none" data-id="element-170" />

      <div className="max-w-4xl mx-auto text-center relative z-10 mt-[-60px] mb-[-60px]" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center space-x-2 bg-dark-card border border-dark-border px-4 py-2 rounded-full mb-8 pt-[2px] pb-[2px]" data-id="element-172">
          <span className="font-bold tracking-widest text-gray-300 text-[12px]" data-id="element-173">
            PROTOCOLO MENTE INDOMABLE™
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="md:text-5xl font-black tracking-tight mb-2 mt-[-30px] text-[22px] pt-[20px]" data-id="element-174">
          Todo tu entrenamiento cognitivo del año.
        </motion.h1>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="md:text-5xl font-black tracking-tight mb-6 text-brand text-[36px] mt-[-20px]" data-id="element-175">
          Listo. Desde hoy.
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex justify-center mb-8" data-id="element-176">
          <img src="https://cdn.magicpatterns.com/uploads/nHde7RoNzuTSLvc78Z4Nfs/mo0ckup.png" alt="Protocolo Mente Indomable" className="max-w-2xl w-full mt-[-20px] mb-[-20px]" data-id="element-177" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mb-10 max-w-2xl mx-auto" data-id="element-178">
          <p className="text-brand mb-2 font-bold text-[18px]" data-id="element-179">
            Sin buscar más. Sin improvisar. Sin excusas.
          </p>
          <p className="text-white mb-[-20px] text-[16px] font-[600] mt-[-10px]" data-id="element-180">
            Ejercicios + Protocolos + Registros + Evaluaciones + Desafíos de
            Campo + Blindaje Mental
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col items-center gap-3 mb-[20px]" data-id="element-181">
          <div className="flex flex-wrap justify-center gap-2" data-id="element-182">
            {[{
            icon: FileText,
            text: '100% PDF'
          }, {
            icon: Zap,
            text: 'Acceso Inmediato'
          }, {
            icon: MapPin,
            text: 'Argentina'
          }].map((badge, i) => <div key={i} className="flex items-center space-x-1 bg-dark-card border border-dark-border px-2 py-1 rounded-md text-xs text-gray-300" data-id="element-183">
                <badge.icon className="w-3 h-3 text-brand" data-id="element-184" />
                <span data-id="element-185">{badge.text}</span>
              </div>)}
          </div>
          <div className="flex items-center space-x-1 bg-brand/10 border border-brand/20 px-3 py-1 rounded-full text-[11px] text-brand font-medium text-center" data-id="element-186">
            <Users className="w-3 h-3 flex-shrink-0" data-id="element-187" />
            <span data-id="element-188">
              Memoria · Velocidad Mental · Lógica · Foco · Blindaje bajo presión
              · Hábitos de alto rendimiento
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-col items-center" data-id="element-189">
          <div className="flex items-center justify-center gap-4 text-gray-400 text-xs font-medium whitespace-nowrap" data-id="element-190">
            <div className="flex items-center space-x-1" data-id="element-191">
              <span data-id="element-192">🛡️</span>
              <span data-id="element-193">Garantía 7 días</span>
            </div>
            <div className="flex items-center space-x-1" data-id="element-194">
              <span data-id="element-195">🔒</span>
              <span data-id="element-196">Pago 100% seguro</span>
            </div>
            <div className="flex items-center space-x-1" data-id="element-197">
              <span data-id="element-198">💳</span>
              <span data-id="element-199">Mercado Pago</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}